(function () {
    'use strict';

    var ivViewerGallery = function ($timeout) {
        return {
            restrict: 'E',
            templateUrl: 'common/directives/templates/ivViewerGallery.html',
            scope: {
                images: '=',
                height: '@',
                width: '@'
            },
            link: function (scope, element, attrs) {
                scope.currentImageIndex = 0;
                var total = scope.images.length;

                var wrapper = element[0];
                var container = $(wrapper).find('.image-container')[0];

                var currentImageViewer;
                $timeout(function () {
                    scope.imageElements = $(container).find('img').toArray();
                    console.log(scope.imageElements);
                    showImage();
                });

                function showImage() {
                    if (currentImageViewer) {
                        currentImageViewer.destroy();
                        currentImageViewer = null;
                    }
                    var imageElement = scope.imageElements[scope.currentImageIndex];
                    var imageEl = angular.element(imageElement);
                    imageEl.css('width', scope.width + 'px');
                    imageEl.css('height', scope.height + 'px');
                    currentImageViewer = new ImageViewer(imageElement);
                }

                scope.showNext = function() {
                    if (scope.currentImageIndex < total - 1) {
                        scope.currentImageIndex++;
                        showImage();
                    }
                };

                scope.showPrevious = function () {
                    if (scope.currentImageIndex > 0) {
                        scope.currentImageIndex--;
                        showImage();
                    }
                };
            }
        }
    };

    ivViewerGallery.$inject = ['$timeout'];
    angular.module('ecap.common').directive('ivViewerGallery', ivViewerGallery);
})();